var login = {
  translation: {
    common: {
      accept: 'Prinyat',
      alreadyUser: 'Uzhe est akkount?',
      and: 'i',
      backToLogin: 'Vernutsya na stranicu vhoda',
      continueWith: 'Prodolzhit cherez {{provider}}',
      createAccount: 'Sozdat akkount',
      createYourAccount: 'Sozdayte akkount',
      emailOrUsername: 'Email ili imya polzovatelya',
      login: 'Voyti',
      logInToBoards: 'Voyti',
      newToBoards: 'Vpervye v RICE-WORK?',
      pageNotFound_title: 'Stranica ne naydena',
      password: 'Parol',
      privacyPolicy: 'Politika konfidencialnosti',
      register: 'Zaregistrirovatsya',
      registerWithGoogle: 'Zaregistrirovatsya cherez Google',
      termsOfService: 'Usloviya ispolzovaniya',
      togglePasswordVisibility: 'Pokazat/skryt parol',
    },

    action: {
      logIn: 'Voyti',
    },
  },
};

export { login as default };
